// أدوات عرض المشاريع للعميل (قراءة فقط).

export const PROJECT_STATUSES = [
    { value: 'running', ar: 'جاري', en: 'Running', bg: '#dcfce7', color: '#15803d', dot: '#22c55e' },
    { value: 'suspended', ar: 'متوقف', en: 'Suspended', bg: '#fef3c7', color: '#b45309', dot: '#f59e0b' },
    { value: 'completed', ar: 'مكتمل', en: 'Completed', bg: '#ccfbf1', color: '#0f766e', dot: '#14b8a6' },
    { value: 'canceled', ar: 'ملغي', en: 'Canceled', bg: '#fee2e2', color: '#b91c1c', dot: '#ef4444' },
];

export const getProjectStatus = (status) =>
    PROJECT_STATUSES.find((item) => item.value === String(status || '').toLowerCase()) || PROJECT_STATUSES[0];

export const formatDate = (raw) => {
    const date = raw ? new Date(raw) : null;
    if (!date || Number.isNaN(date.getTime())) return '-';
    const pad = (num) => String(num).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

// نسبة الوقت اللي عدى من مدة المشروع.
export const getTimeProgress = (project, nowMs = Date.now()) => {
    const start = project?.startAt ? new Date(project.startAt).getTime() : null;
    const end = project?.expectedAt ? new Date(project.expectedAt).getTime() : null;
    if (!start || !end || end <= start) return null;
    return Math.min(100, Math.max(0, Math.round(((nowMs - start) / (end - start)) * 100)));
};

export const ProjectStatusPill = ({ status, lang = 'ar' }) => {
    const meta = getProjectStatus(status);
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: 999, background: meta.bg, color: meta.color, fontSize: 11, fontWeight: 800, whiteSpace: 'nowrap' }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: meta.dot }} />
            {lang === 'ar' ? meta.ar : meta.en}
        </span>
    );
};
